"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Shadify_1 = require("./Shadify");
exports.default = Shadify_1.Shadify;
Object.assign(module.exports, Shadify_1.Shadify);
